// @flow
import React from 'react'
import I18n from 'i18n-react'

export type FilterDomainType = {
  tab: string,
  name: string,
  value: string,
  valueName?: string,
}

type TextFilterProps = {
  checked: boolean,
  customClassNames?: string,
  disabled?: boolean,
  domain: FilterDomainType,
  onChange: (domain: FilterDomainType, checked: boolean) => any,
  parentName?: string,
  textMode: boolean,
}

const QuoteTextFilter = (props: TextFilterProps) => {
  const handleOnChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    props.onChange(props.domain, event.target.checked)
  }

  if (props.textMode) {
    return props.checked &&
      <li className='d-block d-sm-inline-block'>
        <strong>{props.domain.value}</strong>
      </li>
  }

  const id = `filter-${props.domain.tab}-${props.domain.name}-${props.domain.value}`

  return (
    <div className={props.customClassNames || 'col-6 col-md-3 px-0 py-2'}>
      <div className='custom-control custom-checkbox'>
        <input
          checked={props.checked}
          className='custom-control-input'
          data-hj-whitelist
          disabled={props.disabled || false}
          id={id}
          onChange={handleOnChange}
          type='checkbox'
        />
        <label
          className='custom-control-label'
          htmlFor={id}
        >
          {props.domain.valueName
            ? props.domain.valueName
            : I18n.translate(`filter.${props.domain.tab}.${props.domain.value}`)
          }
        </label>
      </div>
    </div>
  )
}

export default QuoteTextFilter
